class ProductMatchingWays extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      this.initQuantityButtons();
      this.updateAllPriceSummaries();
      this.bindHoverEvents();
    }

    bindHoverEvents() {
      const productItems = this.querySelectorAll('.matching-product-item');

      // 显示hover卡片
      function showHoverCard(hoverCard, event) {
          hoverCard.style.display = 'block';
          hoverCard.style.opacity = '0';
          hoverCard.style.transform = 'translateY(10px)';
          
          // 设置初始位置
          updateHoverCardPosition(hoverCard, event);
          
          // 动画显示
          requestAnimationFrame(() => {
              hoverCard.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
              hoverCard.style.opacity = '1';
              hoverCard.style.transform = 'translateY(0)';
          });
      }
      
      // 隐藏hover卡片
      function hideHoverCard(hoverCard) {
          hoverCard.style.transition = 'opacity 0.2s ease, transform 0.2s ease';
          hoverCard.style.opacity = '0';
          hoverCard.style.transform = 'translateY(-10px)';
          
          setTimeout(() => {
              hoverCard.style.display = 'none';
          }, 200);
      }
      
      // 更新hover卡片位置，防止超出屏幕
      function updateHoverCardPosition(hoverCard, event) {
          const card = hoverCard;
          const cardRect = card.getBoundingClientRect();
          const viewportWidth = window.innerWidth;
          const viewportHeight = window.innerHeight;
          
          // 获取卡片尺寸
          const cardWidth = cardRect.width || 300; // 默认宽度
          const cardHeight = cardRect.height || 200; // 默认高度
          
          // 基础偏移量
          const offsetX = 15;
          const offsetY = 15;
          
          // 计算初始位置
          let left = event.clientX + offsetX;
          let top = event.clientY + offsetY;
          
          // 水平边界检测
          if (left + cardWidth > viewportWidth) {
              left = event.clientX - cardWidth - offsetX; // 显示在鼠标左侧
          }
          
          // 垂直边界检测
          if (top + cardHeight > viewportHeight) {
              top = event.clientY - cardHeight - offsetY; // 显示在鼠标上方
          }
          
          // 确保不会超出屏幕左边界和上边界
          left = Math.max(10, left);
          top = Math.max(10, top);
          
          // 应用位置
          card.style.position = 'fixed';
          card.style.left = left + 'px';
          card.style.top = top + 'px';
          card.style.zIndex = '9999';
      }
    
      productItems.forEach(item => {
        const hoverCard = item.querySelector('.hover-card');
        let hoverTimeout;
        
        // 鼠标进入事件
        item.addEventListener('mouseenter', function(e) {
            clearTimeout(hoverTimeout);
            showHoverCard(hoverCard, e);
        });
        
        // 鼠标移动事件 - 更新位置
        item.addEventListener('mousemove', function(e) {
            updateHoverCardPosition(hoverCard, e);
        });
        
        // 鼠标离开事件
        item.addEventListener('mouseleave', function() {
            hoverTimeout = setTimeout(() => {
                hideHoverCard(hoverCard);
            }, 100); // 100ms延迟，避免快速移动时闪烁
        });

        window.addEventListener('resize', function() {
            hideHoverCard(hoverCard);
        });

         window.addEventListener('scroll', function() {
            hideHoverCard(hoverCard);
        });
        
        // hover卡片本身的事件处理
        hoverCard.addEventListener('mouseenter', function() {
            clearTimeout(hoverTimeout);
        });
        
        hoverCard.addEventListener('mouseleave', function() {
            hideHoverCard(hoverCard);
        });
      });
    }
  
    initQuantityButtons() {
      const blocks = this.querySelectorAll('.matching-ways-block');
  
      blocks.forEach(block => {
        block.querySelectorAll('.quantity-btn').forEach(button => {
          button.addEventListener('click', () => {
            const action = button.dataset.action;
            const input = button.closest('.matching-product-quantity').querySelector('.quantity-input');
            let value = parseInt(input.value) || 0;
  
            if (action === 'increase') {
              value += 1;
            } else if (action === 'decrease' && value > 0) {
              value -= 1;
            }
  
            input.value = Math.max(0, value);
  
            // 更新对应分组的价格汇总
            this.updatePriceSummary(block);
            this.updateFormAddOnIds();
          });
        });
      });
    }
  
    updatePriceSummary(block) {
      const items = block.querySelectorAll('.matching-product-item');
      let totalPrice = 0;
  
      items.forEach(item => {
        const quantity = parseInt(item.querySelector('.quantity-input').value) || 0;
        const price = parseFloat(item.dataset.price);
  
        if (!isNaN(quantity) && !isNaN(price)) {
          totalPrice += quantity * price;
        }
      });
  
      const groupIndex = block.dataset.groupIndex;
      const summaryElement = this.querySelector(`#price-summary-${groupIndex}`);
      const totalPriceElement = summaryElement.querySelector('.total-price');
  
      if (summaryElement) {
        totalPriceElement.textContent = theme.formatMoney(totalPrice);
        summaryElement.style.display = totalPrice > 0 ? 'block' : 'none';
      }
    }
  
    updateAllPriceSummaries() {
      this.querySelectorAll('.matching-ways-block').forEach(this.updatePriceSummary.bind(this));
    }


    updateFormAddOnIds() {
      const form = this.closest('[data-product-info]')?.querySelector('form');
      if (!form) return;
      var addOnIdsInput = form.querySelector('[name="_add_on_ids"]');
      if (!addOnIdsInput) {
        form.insertAdjacentHTML('beforeend', '<input type="hidden" name="_add_on_ids" value="">');
        addOnIdsInput = form.querySelector('[name="_add_on_ids"]');
      }
      const addOnIds = [];
      Array.from(this.querySelectorAll('.matching-product-item')).forEach(item => {
        if (parseInt(item.querySelector('.quantity-input').value) > 0) {
          addOnIds.push(item.dataset.variantId);
        }
      })
      if (addOnIds.length > 0) {
        addOnIdsInput.setAttribute('value', addOnIds.join(','));
      }
    }

}
if (!customElements.get('product-matching-ways')) {
  customElements.define('product-matching-ways', ProductMatchingWays);
}